/// <reference path="components/admin/affiliatereport/affiliateusermasterreport.jsx" />
import { Suspense, lazy, useEffect, useState } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import CountryMetaMaster from './components/Admin/Pages/CountryMetaMaster'
import DeviceMaster from './components/Admin/Pages/DeviceMaster'
import Import from './components/Admin/Pages/Import'
import UserMasterNew from './components/Admin/Pages/NewUserMaster'
import PaymentDiscrepancyLogReport from './components/Admin/Pages/PaymentDiscrepancyLogReport'
import PromotionMaster from './components/Admin/Pages/PromotionMaster'
import UploadPlanImage from './components/Admin/Pages/UploadPlanImage'
import Thankyou from './components/Common/Thankyou'
import VerifyPaymentStatus from './components/Common/VerifyPaymentStatus'
import Addonplans from './components/pages/Addonplans'
import Affliate from './components/pages/Affliate'
import ForgotPassword from './components/pages/ForgotPassword'
import Plans from './components/pages/Plans'
import Privacypolicy from './components/pages/Privacypolicy'
import RefundPolicy from './components/pages/RefundPolicy'
import ResetPasswordField from './components/pages/ResetPasswordField'
import TermAndConditions from './components/pages/TermAndConditions'
import ViewAllDestination from './components/pages/ViewAllDestination'
import CheckAuthenticationForPayment from './components/pages/checkAuthenticationForPayment'
import OrderFailed from './components/Common/OrderFailed'
import MoneyBackPolicy from './components/pages/MoneyBackPolicy'

const SimflyPartnerPlateform = lazy(() => import('./components/pages/Partnerwithus/SimflyPartnerPlateform'))
const Destination = lazy(() => import('../src/components/pages/Destination'))
const Home = lazy(() => import('../src/components/pages/Home'))
const AuthLayout = lazy(() => import('./components/Admin/Layout/AuthLayout'))
const AdminLogin = lazy(() => import('./components/Admin/Login/AdminLogin'))
const ChangePassword = lazy(() => import('./components/Admin/Pages/ChangePassword'))
const GroupMaster = lazy(() => import('./components/Admin/Pages/GroupMaster'))
const GroupMenuAccess = lazy(() => import('./components/Admin/Pages/GroupMenuAccess'))
const ResetPassword = lazy(() => import('./components/Admin/Pages/ResetPassword'))
const UserLogReport = lazy(() => import('./components/Admin/Pages/UserLogReport'))
const UserMaster = lazy(() => import('./components/Admin/Pages/UserMaster'))
const UserMenuAccess = lazy(() => import('./components/Admin/Pages/UserMenuAccess'))
const Checkout = lazy(() => import('./components/Common/Checkout'))
const Pagenotfound = lazy(() => import('./components/Common/Pagenotfound'))
const AdminLayout = lazy(() => import('./components/Layout/AdminLayout'))
const MainLayout = lazy(() => import('./components/Layout/MainLayout'))
const Profile = lazy(() => import('./components/pages/Profile/Profile'))
const Customer = lazy(() => import('./components/Admin/Pages/Customer'))
const OrderReport = lazy(() => import('./components/Admin/Pages/OrderHistory'))
const PlanMaster = lazy(() => import('./components/Admin/Pages/PlanMaster'))
const PlanImageMaster = lazy(() => import('./components/Admin/Pages/PlanImageMaster'))
const GeneralMaster = lazy(() => import('./components/Admin/Pages/GeneralMaster'))
const CustomerReport = lazy(() => import('./components/Admin/Pages/CustomerReport'))
const Dashboard = lazy(() => import('./components/Admin/Pages/Dashboard'))
const FAQs = lazy(() => import('./components/pages/FAQs'))
const Contactus = lazy(() => import('./components/pages/Contactus'))
const Aboutus = lazy(() => import('./components/pages/Aboutus'))
const Login = lazy(() => import('./components/Login/login'))

const AffiliateUserMasterReport = lazy(() => import('./components/Admin/AffiliateReport/AffiliateUserMasterReport'))
const AffiliateSimReport = lazy(() => import('./components/Admin/AffiliateReport/AffiliateSimReport'))
const AffiliateOrderReport = lazy(() => import('./components/Admin/AffiliateReport/AffiliateOrderReport'))
const AffiliatePayoutReport = lazy(() => import('./components/Admin/AffiliateReport/AffiliatePayoutReport'))
const AffiliateMakePayment = lazy(() => import('./components/Admin/AffiliateReport/AffiliateMakePayment'))
const CommissionTypeMaster = lazy(() => import('./components/Admin/AffiliateReport/CommissionTypeMaster'))

export const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return null;
}

const App = () => {
    const [auth, setAuth] = useState(false)
    const authEmail = localStorage.getItem('emailID')
    const authLoginToken = localStorage.getItem('loginToken')
    const authLoginUserCode = localStorage.getItem('loginUserCode')


    const location = useLocation();

    useEffect(() => {
        let testt = authEmail !== null && authLoginToken !== null && authLoginUserCode !== null;
        setAuth(testt)
    }, [location]);
   

    return (
        <>
            <ScrollToTop />
            {/*  <Loader/> */}
            <ToastContainer position="bottom-center" newestOnTop={true} />
            <Suspense>
                <Routes>
                    <Route path='/' element={<MainLayout />}>
                        <Route index element={<Home />} />
                        <Route path='*' element={<Pagenotfound />} />
                        <Route path='/login' element={
                            auth ?
                                <Home /> : <Login />
                        } />
                      {/*  <Route path='/destination' element={<Destination />} />*/}
                        <Route path='/esim-plans/:Id' element={<Plans />} />
                        <Route path='/destinations' element={<ViewAllDestination />} />
                        <Route path='/profile' element={<Profile />} />
                        <Route path='/checkout' element={<Checkout />} />
                        <Route path='/affiliate' element={<Affliate />} />
                        <Route path='/CreateOrder' element={<VerifyPaymentStatus />} />
                        <Route path='/thankyou' element={<Thankyou />} />
                        <Route path='/Orderfailed' element={<OrderFailed />} />
                        <Route path='/simfly-new-partner-platform' element={<SimflyPartnerPlateform />} />
                        <Route path='/aboutus' element={<Aboutus />} />
                        <Route path='/contactus' element={<Contactus />} />
                        <Route path='/authentication' element={<CheckAuthenticationForPayment />} />
                        <Route path='/FAQs' element={<FAQs />} />
                        <Route path='/privacy-cookie-policy' element={<Privacypolicy />} />
                        <Route path='/term-and-conditions' element={<TermAndConditions />} />
                        <Route path='/refund-policy' element={<RefundPolicy />} />
                        <Route path='/add-on-plans' element={<Addonplans />} />
                        <Route path='/forgot-password' element={<ForgotPassword />} />
                        <Route path='/resetPasswordSlide' element={<ResetPasswordField />} />
                        <Route path='/terms-conditions' element={<TermAndConditions/>} />
                        <Route path='/money-back-policy' element={<MoneyBackPolicy/>} />
                    </Route>
                    <Route path='/admin/*' element={<AdminLayout />}>
                        <Route index element={<AdminLogin />} />
                        <Route path="" element={<AuthLayout />}>
                            <Route path='*' element={<Pagenotfound />} />
                            <Route path="UserMaster" element={<UserMaster />} />
                            <Route path="ResetPassword" element={<ResetPassword />} />
                            <Route path="ChangePassword" element={<ChangePassword />} />
                            <Route path="GroupMenuAccess" element={<GroupMenuAccess />} />
                            <Route path="UserMenuAccess" element={<UserMenuAccess />} />
                            <Route path="GroupMaster" element={<GroupMaster />} />
                            <Route path="UserLogReport" element={<UserLogReport />} />
                            <Route path="CustomerMaster" element={<Customer />} />
                            <Route path="OrderReport" element={<OrderReport />} />
                            <Route path="PlanMaster" element={<PlanMaster />} />
                            <Route path="DeviceMaster" element={<DeviceMaster />} />
                            <Route path="PlanImageMaster" element={<PlanImageMaster />} />
                            <Route path="CustomerReport" element={<CustomerReport />} />
                            <Route path="newUserMAster" element={<UserMasterNew />} />
                            <Route path="GeneralMaster" element={<GeneralMaster />} />
                            <Route path="PromotionMaster" element={<PromotionMaster />} />
                            <Route path="ImportPlanDetails" element={<Import />} />
                            <Route path="UploadPlanImage" element={<UploadPlanImage />} />
                            <Route path="PaymentDiscrepancyLog" element={<PaymentDiscrepancyLogReport />} />
                            <Route path="AffiliateUserMasterReport" element={<AffiliateUserMasterReport />} />
                            <Route path="AffiliateSimReport" element={<AffiliateSimReport />} />
                            <Route path="AffiliateOrderReport" element={<AffiliateOrderReport />} />
                            <Route path="AffiliatePayoutReport" element={<AffiliatePayoutReport />} />
                            <Route path="AffiliateMakePayment" element={<AffiliateMakePayment />} />
                            <Route path="CommissionTypeMaster" element={<CommissionTypeMaster />} />
                            <Route path="CountryMetaMaster" element={<CountryMetaMaster />} />
                            <Route path="Dashboard" element={<Dashboard />} />
                        </Route>
                    </Route>
                </Routes>
            </Suspense>
        </>
    )
}

export default App;